import _toConsumableArray from "/home/shipsy/crm-logistics-frontend/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/toConsumableArray";
import _slicedToArray from "/home/shipsy/crm-logistics-frontend/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/slicedToArray";
var __rest = this && this.__rest || function (s, e) {
  var t = {};
  for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
  if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
    if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
  }
  return t;
};
import { deepMix } from '@antv/util';
import { max as d3Max, mean as d3Mean, sum as d3Sum, min as d3Min, median as d3Median } from 'd3-array';
import { indexOf } from '../utils/array';
import { columnOf, column, nonConstantColumn } from './utils/helper';
function builtinFormatter(summary) {
  return function (d) {
    return d === null ? summary : "".concat(summary, " of ").concat(d);
  };
}
function normalizeReducer(reducer) {
  if (typeof reducer === 'function') return [reducer, null];
  var registry = {
    mean: mean,
    max: max,
    count: count,
    first: first,
    last: last,
    sum: sum,
    min: min,
    median: median
  };
  var reducerFunction = registry[reducer];
  if (!reducerFunction) throw new Error("Unknown reducer: ".concat(reducer, "."));
  return reducerFunction();
}
function mean() {
  var reducer = function reducer(I, V) {
    return d3Mean(I, function (i) {
      return +V[i];
    });
  };
  var formatter = builtinFormatter('mean');
  return [reducer, formatter];
}
function median() {
  var reducer = function reducer(I, V) {
    return d3Median(I, function (i) {
      return +V[i];
    });
  };
  var formatter = builtinFormatter('median');
  return [reducer, formatter];
}
function max() {
  var reducer = function reducer(I, V) {
    return d3Max(I, function (i) {
      return +V[i];
    });
  };
  var formatter = builtinFormatter('max');
  return [reducer, formatter];
}
function min() {
  var reducer = function reducer(I, V) {
    return d3Min(I, function (i) {
      return +V[i];
    });
  };
  var formatter = builtinFormatter('min');
  return [reducer, formatter];
}
function count() {
  var reducer = function reducer(I, V) {
    return I.length;
  };
  var formatter = builtinFormatter('count');
  return [reducer, formatter];
}
function sum() {
  var reducer = function reducer(I, V) {
    return d3Sum(I, function (i) {
      return +V[i];
    });
  };
  var formatter = builtinFormatter('sum');
  return [reducer, formatter];
}
function first() {
  var reducer = function reducer(I, V) {
    return V[I[0]];
  };
  var formatter = builtinFormatter('first');
  return [reducer, formatter];
}
function last() {
  var reducer = function reducer(I, V) {
    return V[I[I.length - 1]];
  };
  var formatter = builtinFormatter('last');
  return [reducer, formatter];
}
/**
 * The Group transform group data by x and y channels, and aggregate.
 */
export var GroupN = function GroupN() {
  var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var groupBy = options.groupBy,
    rest = __rest(options, ["groupBy"]);
  return function (I, mark) {
    var data = mark.data,
      encode = mark.encode;
    var groups = groupBy(I, mark);
    if (!groups) return [I, mark];
    // Extract field from from channel
    // x1 from x, y1 from y, etc,.
    var maybeFrom = function maybeFrom(field, reducer) {
      if (field) return field;
      var from = reducer.from;
      if (!from) return field;
      var _columnOf = columnOf(encode, from),
        _columnOf2 = _slicedToArray(_columnOf, 2),
        field1 = _columnOf2[1];
      return field1;
    };
    var outputs = Object.entries(rest).map(function (_ref) {
      var _ref2 = _slicedToArray(_ref, 2),
        channel = _ref2[0],
        reducer = _ref2[1];
      var _normalizeReducer = normalizeReducer(reducer),
        _normalizeReducer2 = _slicedToArray(_normalizeReducer, 2),
        reducerFunction = _normalizeReducer2[0],
        formatter = _normalizeReducer2[1];
      var _columnOf3 = columnOf(encode, channel),
        _columnOf4 = _slicedToArray(_columnOf3, 2),
        V = _columnOf4[0],
        field = _columnOf4[1];
      var field1 = maybeFrom(field, reducer);
      var RV = groups.map(function (I) {
        return reducerFunction(I, V !== null && V !== void 0 ? V : data);
      });
      return [channel, Object.assign(Object.assign({}, nonConstantColumn(RV, (formatter === null || formatter === void 0 ? void 0 : formatter(field1)) || field1)), {
        aggregate: true
      })];
    });
    var reducedColumns = Object.keys(encode).map(function (key) {
      var _columnOf5 = columnOf(encode, key),
        _columnOf6 = _slicedToArray(_columnOf5, 2),
        V = _columnOf6[0],
        fv = _columnOf6[1];
      var GV = groups.map(function (I) {
        return V[I[0]];
      });
      return [key, column(GV, fv)];
    });
    var GD = groups.map(function (I) {
      return data[I[0]];
    });
    var GI = indexOf(groups);
    return [GI, deepMix({}, mark, {
      data: GD,
      encode: Object.fromEntries([].concat(_toConsumableArray(reducedColumns), _toConsumableArray(outputs)))
    })];
  };
};
GroupN.props = {};